{{#if this.submissions}}
  <div class="wizard-header large">
    <label>
      {{i18n "admin.wizard.submissions.title" name=this.wizard.name}}
    </label>

    <div class="controls">
      {{d-button
        icon="sliders"
        label="admin.wizard.edit_columns"
        action=(action "showEditColumnsModal")
        class="btn-default open-edit-columns-btn download-link"
      }}
    </div>

    <a
      class="btn btn-default download-link"
      href={{this.downloadUrl}}
      target="_blank"
      rel="noopener noreferrer"
    >
      {{d-icon "download"}}
      <span class="d-button-label">
        {{i18n "admin.wizard.submissions.download"}}
      </span>
    </a>
  </div>

  <div class="wizard-table">
    {{#load-more selector=".wizard-table tr" action=(action "loadMore")}}
      {{#if this.noResults}}
        <p>{{i18n "search.no_results"}}</p>
      {{else}}
        <table>
          <thead>
            <tr>
              {{#each this.fields as |field|}}
                {{#if field.enabled}}
                  <th>
                    {{field.label}}
                  </th>
                {{/if}}
              {{/each}}
            </tr>
          </thead>
          <tbody>
            {{#each this.displaySubmissions as |submission|}}
              <tr>
                {{#each-in submission as |field value|}}
                  <td>{{wizard-table-field field=field value=value}}</td>
                {{/each-in}}
              </tr>
            {{/each}}
          </tbody>
        </table>
      {{/if}}

      {{conditional-loading-spinner condition=this.loadingMore}}
    {{/load-more}}
  </div>
{{/if}}